export enum SignType {
  link = 'LINK',
  unlockContent = 'UNLOCK_CONTENT',
  email = 'EMAIL',
}

export const signWalletLinking =
  'Permission to link your wallet to a valid Mogul Account once logged in';

export const signWalletUnlockableContent =
  'I declare that I am the rightful owner of this wallet.';

export const signEmail = 'Permission to send email notifications';

export const resolveSigningMessage = (msgType: SignType) => {
  switch (msgType) {
    case SignType.link:
      return signWalletLinking;
    case SignType.unlockContent:
      return signWalletUnlockableContent;
    case SignType.email:
      return signEmail;
  }
};
